import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-content" style={{ textAlign: 'center' }}>
        <p className="footer-text">
          © {currentYear} Lila&Quendal.
        </p>
      </div>
    </footer>
  );
};

export default Footer;